<template>
  <div class="body">
    <div class="header">
      <el-form :model="PointConsumeFindDTO" :inline="true">
        <el-form-item label="上传日期">
          <el-date-picker
            v-model="date"
            type="daterange"
            :picker-options="cellClassName"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="chooeDate"
          ></el-date-picker>
        </el-form-item>
        
          <el-form-item label="云项目名称:">
            <el-input
              v-model="PointConsumeFindDTO.funName"
              placeholder="材料种类"
            ></el-input>
          </el-form-item>
          <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
            搜索
          </el-button>
          <br>
        <el-form-item>
          <!-- <el-button  class="btn-style btn-cancel" type="primary" @click="tohandleEdit">新增</el-button>
          <el-button  class="btn-style btn-delete"  type="danger" @click="handleDelete">删除</el-button> -->
          
        </el-form-item>

        <div class="x_flex gap50 mb-10" style="margin-left: 50px">
                 <p>
                            <span class="table-label">  我的积分余额:&#8195;</span>
                            <span class="table-value" style="color: #18b6f5;">{{point}}</span>
                        </p>
                      
                </div>
                
      </el-form>
      
      <el-dialog
      text-align="center"
              :close-on-click-modal="false"
              title="无边字面板设置"
              class="order-dialog"
              width="75%"
              center
              :visible.sync="drawer"
    >
      <el-form
      ref="accountForm"
                  :model="accountForm"
                  class="demo-accountForm form-style"
      >
      <div class="accountForm-header">
      <el-row :gutter="20">
                          <el-col :span="8">
                              <el-form-item label="方案名称">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.name"
                                      placeholder="请输入方案名称"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="转速">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.speed"
                                      placeholder="请输入转速"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="进给速度">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.feedSpeed"
                                      placeholder="请输入进给速度"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                      </el-row>


                      <el-row :gutter="20">
                          <el-col :span="8">
                              <el-form-item label="切断下刀z值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.lowerKnife"
                                      placeholder="请输入切断下刀z值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="抬刀z值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.cutterLifting"
                                      placeholder="请输入抬刀z值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="刀具直径">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.toolDiameter"
                                      placeholder="请输入刀具直径"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                      </el-row>
      
                      <el-row :gutter="20">
                          <el-col :span="8">
                              <el-form-item label="切断刀螺旋率">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.helixRate"
                                      placeholder="切断刀螺旋率"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="刀具编号">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.toolNumber"
                                      placeholder="请输入刀具编号"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="切割方式" size="small" >
                    <el-select clearable size="small" v-model.trim="accountForm.cutWay" allow-create
                                     filterable
                                    >
                              <el-option
                                  v-for="item in cutWay"
                                  clearable
                                  :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                          </el-select>
                  </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="20">
                          <el-col :span="8">
                            <el-form-item label="板材厚度">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.plateThickness"
                                      placeholder="请输入板材厚度"
                                  ></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="8">
                            <!-- <el-form-item label="边缘尺寸">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.edgeSize"
                                      placeholder="请输入边缘尺寸"
                                  ></el-input>
                              </el-form-item> -->
                            </el-col>
                            <el-col :span="8">
                            <el-form-item label="切槽刀下刀z值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.groovingCutter"
                                      placeholder="请输入切槽刀下刀z值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          </el-row>

                          <el-row :gutter="20">

                          <el-col :span="8">
                              <el-form-item label="切槽刀编号">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.slotCutterNumber"
                                      placeholder="请输入切槽刀编号"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="切槽刀螺旋率">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.slotCutterHelicity"
                                      placeholder="请输入切槽刀螺旋率"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                                  <el-form-item label="两刀是否合并" size="small" >
                    <el-select clearable size="small" v-model.trim="accountForm.mergeType" allow-create
                                     filterable
                                    >
                              <el-option
                                  v-for="item in mergeType"
                                  clearable
                                  :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                          </el-select>
                  </el-form-item>
                </el-col>
                          </el-row>
                          <el-row :gutter="20">
                  <el-col :span="8">
                              <el-form-item label="外扩/内缩" size="small" >
                    <el-select clearable size="small" v-model.trim="accountForm.boundary" allow-create
                                     filterable
                                    >
                              <el-option
                                  v-for="item in boundary"
                                  clearable
                                  :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                          </el-select>
                  </el-form-item>
                            </el-col>
                            <el-col :span="8">
                              <el-form-item label="外扩/内缩值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.boundaryValue"
                                      placeholder="请输入外扩/内缩值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                         
                          </el-row>
             
        <el-form-item >
          <el-button
            
            type="primary"
            @click="submitForm('accountForm')"
          >
            立即创建
          </el-button>
        </el-form-item>
        </div>
      </el-form>
    </el-dialog>
      <div style="display: flex">
        
        <!-- <el-button
          
          style="margin-left: 10px"
          type="primary"
          @click="exportExcelData"
        >
          导出
        </el-button> -->
      </div>
    </div>
    <password ></password>

    <el-dialog title="编辑无边字面板设置" :visible.sync="dialogVisible"      text-align="center"
              :close-on-click-modal="false"
              class="order-dialog"
              width="75%"
              center>
      <el-form
      ref="accountForm"
                  :model="accountForm"
                  class="demo-accountForm form-style"
      >
      <div class="accountForm-header">
      <el-row :gutter="20">
                          <el-col :span="8">
                              <el-form-item label="方案名称">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.name"
                                      placeholder="请输入方案名称"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="转速">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.speed"
                                      placeholder="请输入转速"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="进给速度">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.feedSpeed"
                                      placeholder="请输入进给速度"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                      </el-row>


                      <el-row :gutter="20">
                          <el-col :span="8">
                              <el-form-item label="切断下刀z值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.lowerKnife"
                                      placeholder="请输入切断下刀z值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="抬刀z值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.cutterLifting"
                                      placeholder="请输入抬刀z值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="刀具直径">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.toolDiameter"
                                      placeholder="请输入刀具直径"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                      </el-row>
      
                      <el-row :gutter="20">
                          <el-col :span="8">
                              <el-form-item label="切断刀螺旋率">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.helixRate"
                                      placeholder="切断刀螺旋率"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="刀具编号">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.toolNumber"
                                      placeholder="请输入刀具编号"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="切割方式" size="small" >
                    <el-select clearable size="small" v-model.trim="accountForm.cutWay" allow-create
                                     filterable
                                    >
                              <el-option
                                  v-for="item in cutWay"
                                  clearable
                                  :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                          </el-select>
                  </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="20">
                          <el-col :span="8">
                            <el-form-item label="板材厚度">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.plateThickness"
                                      placeholder="请输入板材厚度"
                                  ></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="8">
                            <!-- <el-form-item label="边缘尺寸">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.edgeSize"
                                      placeholder="请输入边缘尺寸"
                                  ></el-input>
                              </el-form-item> -->
                            </el-col>
                            <el-col :span="8">
                            <el-form-item label="切槽刀下刀z值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.groovingCutter"
                                      placeholder="请输入切槽刀下刀z值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          </el-row>

                          <el-row :gutter="20">

                          <el-col :span="8">
                              <el-form-item label="切槽刀编号">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.slotCutterNumber"
                                      placeholder="请输入切槽刀编号"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="切槽刀螺旋率">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.slotCutterHelicity"
                                      placeholder="请输入切槽刀螺旋率"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                                  <el-form-item label="两刀是否合并" size="small" >
                    <el-select clearable size="small" v-model.trim="accountForm.mergeType" allow-create
                                     filterable
                                    >
                              <el-option
                                  v-for="item in mergeType"
                                  clearable
                                  :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                          </el-select>
                  </el-form-item>
                </el-col>
                          </el-row>
                          <el-row :gutter="20">
                  <el-col :span="8">
                              <el-form-item label="外扩/内缩" size="small" >
                    <el-select clearable size="small" v-model.trim="accountForm.boundary" allow-create
                                     filterable
                                    >
                              <el-option
                                  v-for="item in boundary"
                                  clearable
                                  :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                          </el-select>
                  </el-form-item>
                            </el-col>
                            <el-col :span="8">
                              <el-form-item label="外扩/内缩值">
                                  <el-input
                                      class="input-name"
                                      size="small"
                                      v-model="accountForm.boundaryValue"
                                      placeholder="请输入外扩/内缩值"
                                  ></el-input>
                              </el-form-item>
                          </el-col>
                         
                          </el-row>
             
        <el-form-item >
          <el-button  @click="dialogVisible = false">取 消</el-button>
        <el-button  type="primary" @click="editAccount()">
          确 定
        </el-button>
        </el-form-item>
        </div>
      </el-form>
 
    </el-dialog>
    <div class="pagination">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="设置时间"
            width="175"
          ></el-table-column>
          <el-table-column
    prop="thumbnail"
    label="缩略图"
    align="center"
    width="200" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnail"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnail" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnail" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
          <el-table-column
            prop="fileName"
            align="center"
            label="文件名"
          ></el-table-column>
          <el-table-column
            prop="largeCategory"
            align="center"
            label="产品"
          ></el-table-column>
          <el-table-column
            prop="subclass"
            align="center"
            label="材料"
          ></el-table-column>
          <el-table-column
            prop="funName"
            align="center"
            label="云计算项目"
          ></el-table-column>
          <el-table-column
            prop="fileSize"
            align="center"
            label="用料评估"
          ></el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="收费标准/M"
          ></el-table-column>
          <el-table-column
            prop="deductPoints"
            align="center"
            label="扣除积分"
          ></el-table-column>
   
        
        </el-table>
      </div>

    <div class="pagination">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
 import password from '@/components/password.vue';
import { selectPointConsume,getBalance} from '@/api/set/pointConsme.js'
export default {
  components: {
      password
  },
  data() {
    return {
      pageSize: 10,
      total: 0,
      currentPage: 1,
      multipleSelection: [],
      ids: '',
      cellClassName: {
        shortcuts: [
        {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              picker.$emit('pick', [start, end])
            }
          }
        ]

      },
      date: '',
      conTract: [],
      point:'',
      PointConsumeFindDTO:{
        access:'',
          startTime: '',
          endTime:'',
          name: '',
      },
      cutWay:[{
      value: '0',
      label: '原线'
    }, {
      value: '1',
      label: '外切'
    },
    {
      value: '2',
      label: '内切'
    }],
    boundary:[{
      value: '0',
      label: '内缩'
    }, {
      value: '1',
      label: '外扩'
    },],
    mergeType:[{
      value: '0',
      label: '合并'
    }, {
      value: '1',
      label: '不合并'
    },],
      category:[],
      drawer: false,
      dialogVisible:false,
      accountForm:{
        id:'',
        access:'',
        name:'',
        speed:'',
        feedSpeed:'',
        cutterLifting:'',
        cutWay:'',
        toolDiameter:'',
        helixRate:'',
        toolNumber:'',
        plateThickness:'',
        edgeSize:'',
        boundary:'',
        groovingCutter:'',
        slotCutterNumber:'',
        slotCutterHelicity:'',
        mergeType:'',
        boundaryValue:''
      },
      searchForm: {
        startTime: '',
        secondStartTime: '',
        number: '',
        values: ''
      },
      DeleteDTO:{
        id:'',
        status:''
      }

    }
  },
  

  mounted() {
    this.PointConsumeFindDTO.access=localStorage.getItem("access")
    this.accountForm.access=localStorage.getItem("access")
    this.getBalance()
    this.getTableData() // 进入页面调用一次获取数据的方法
  },
  methods: {
    styleBack({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex == 0) {
      //   return { color: '#0c87ef' }
      // }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getTableData()
    },
    tohandleEdit(){
      this.accountForm = Object.assign({},this.$options.data().accountForm);
      this.accountForm.access=localStorage.getItem("access")
      this.drawer = true
    },
    handleEdit(row) {
      this.dialogVisible = true
      this.accountForm= row
    },
    getTableData() {
      selectPointConsume(this.currentPage, this.pageSize, this.PointConsumeFindDTO).then((res) => {
          console.log(res);
        this.conTract = res.data.data.records
        this.total = Number(res.data.data.total)
      })
    },
    getBalance(){
      getBalance(localStorage.getItem("access")).then((res) => {
          this.point=res.data.data.balance
      })
    },
    submitForm(accountForm) {
      this.$refs[accountForm].validate((valid) => {
        if (valid) {
          addBorderlessGraveSet(this.accountForm).then((res) => {
                if (res.data.msg === '操作成功') {
            this.drawer = false
            this.$message({
              type: 'success',
              message: '添加成功!',
              
            }),
            this.getTableData()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
 //修改
 editAccount() {
  upDateBorderlessGraveSet(this.accountForm).then((res) => {
        console.log(res.status)
        if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '修改成功!',
            }),
            this.getTableData()
            this.dialogVisible = false
          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
      })
    },
    handleDelete(row) {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选呢!"
            });
            return;
          } 
    this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        bathDeleteBorderlessGraveSet(this.multipleSelection).then((res) => {
          if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '删除成功!',
            }),
            this.getTableData()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  },
   

  
    deleteInfo(){
      bathDeleteFile(this.multipleSelection).then((res) => {
          if(res.data.code===10000){
            this.getTableData()
          }
      })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    exportExcelData() {
      exportData(this.searchForm, this.currentPage, this.total)
        .then((res) => {
          if (res.status == 200) {
            exportExcel(res.data, res)
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    chooeDate(e) {
      // console.log(e)
      if (e) {
        this.PointConsumeFindDTO.startTime = e[0]
        this.PointConsumeFindDTO.endTime = e[1]
      } else if (!e) {
        this.PointConsumeFindDTO.startTime = ''
        this.PointConsumeFindDTO.endTime = ''
      }
    },
    // 搜索
    serchInfo() {
      this.getTableData()
    },
    categorySelect(e) {
              if(e.target.value) { 
                  this.accountForm.category = e.target.value
          }
      },
      
 
  }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
}

.body {
    overflow: auto;
}

.pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
}

.el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
.goodsTableData{
    margin: 20px 0 ;
}
.btn-style{
    min-width: 72px;
    border-radius: 8px;
}
.btn-search{
    background: var(--theme-color);
}
.btn-buy{
    background: #FF8429;
}
.btn-print{
    background: #4093FF;
}
.btn-delete{
    background: #FF4D4D;
}
.btn-view{
    background: var(--theme-color);
}
.product-form .el-form-item{
    margin-bottom: 0;
}
.table-content{
    margin: 20px;
}
.check-all{
    color: #333;
    font-size: 16px;
    margin-right: 20px;
    cursor: pointer;
}
.el-pagination{
    margin: 0;
}

.el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
    border-radius: 8px;
}

.table-label{
    color: var(--secondColor);
}
.table-value{
    color: var(--color);
}
.table-info{
    width: 80%;
    justify-content: space-between;
}
.table-info > p{
    display: inline-block;
    width: 150px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-item{
    background: #F7F7F7;
    margin: 8px 0;
    border-radius: 12px;
    padding: 12px;
}
.table-image{
    width: 100px;
    height: 50px;
    margin-right: 20px;
}
::v-deep.table-image .image-slot{
    height: 50px;
    display: flex;
    align-items: center;
}
::v-deep.table-image .image-slot i{
    font-size: 50px;
}
.pay{
    color:var(--theme-color);
}
.no-pay{
    color:#FF4D4D;
}
.btn-group{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.btn-group .el-button{
    border-radius: 20px;
    width: 76px;
}
.btn-collection{
    background: #F9DDDD;
}
.btn-view-detail{
    background: #D3F2E4;
    color: var(--theme-color);
}
.btn-reckon{
    background: rgb(245, 233, 212);
  
}

::v-deep.order-dialog .el-dialog{
    border-radius: 24px;
}
.operator label{
    letter-spacing: 5px;
}
::v-deep.dialog-upload{
    display: flex;
}
::v-deep.dialog-upload .el-form-item__label{
    flex-shrink: 0;
}
::v-deep.dialog-upload .el-form-item__content{
    justify-content: right;
}
::v-deep.dialog-upload .avatar-uploader{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #D8E0DD;
}
::v-deep.dialog-upload .el-upload--text{
    width: 100%;
    height: 100%;
}
::v-deep.dialog-upload img{
    max-width: 100px;
}
.accountForm-header{
    background: #F7F7F7;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 20px;
}
.btn-add{
    background: #FF8429;
    border-radius: 8px;
}
.form-submit{
    background: var(--theme-color);
    border-radius: 8px;
}
::v-deep.el-table thead th{
    background: #EAF4F0;
    color: var(--secondColor);
}
.table-no-pay{
    background: #ffeded;
}

::v-deep.el-icon-remove-outline{
    font-size: 32px;
    color: #a3d8f9cc;
}
</style>
